import { jsx as _jsx } from "react/jsx-runtime";
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import useBackButton from '@/hooks/useBackButton';
import { Button } from '@mantine/core';
import styles from './BackButton.module.scss';
export default function BackButton(param) {
    var fallbackParams = param.fallbackParams, children = param.children;
    var back = useBackButton(fallbackParams).back;
    return /*#__PURE__*/ _jsx(Button, {
        variant: "link",
        onClick: back,
        classNames: {
            inner: styles.backButtonInner
        },
        leftSection: /*#__PURE__*/ _jsx(FontAwesomeIcon, {
            icon: faArrowLeft
        }),
        children: children
    });
}
